import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialog,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatBadgeModule } from "@angular/material/badge";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { HasPermissionPipe } from 'app/core/permission/pipes/has-permission.pipe';
import { PermissionService } from 'app/core/permission/services/permission.service';
import { ROUTES_PERMISSIONS } from 'app/common/constants/permission';
import FrequenciesAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity";
import { ICreateSubRouteFrequency } from "../sub-routes-frequency/interfaces/create-sub-route-frequency.interface";
import { SubRouteFrequenciesService } from "../sub-routes-frequency/sub-route-frequency.service";
import { FrecuencyModalComponent } from "../sub-route-delivery-times/frecuency/frecuency.component";
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from "@angular/material/checkbox";
import { DeleteConfirmationComponent } from "app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component";

@Component({
  selector: "app-add-sub-route-add-frequency-modal",
  styleUrl: "./sub-route-add-frequency.component.scss",
  templateUrl: "./sub-route-add-frequency.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatBadgeModule,
    MatSlideToggle,
    MatCheckboxModule,
    HasPermissionPipe,
  ],
})
export class AddFrequencies {
  readonly PERMISSIONS_FREQUENCIES = ROUTES_PERMISSIONS.FREQUENCIES;

  daysList: { day: string; value: number }[] = [
    { day: "LU", value: 1 },
    { day: "MA", value: 2 },
    { day: "MI", value: 3 },
    { day: "JU", value: 4 },
    { day: "VI", value: 5 },
    { day: "SA", value: 6 },
    { day: "DO", value: 7 },
  ];
  openFormAdd = false;
  weekDays = [];
  listCollaboratorsAdd: FrequenciesAttributes[] = [];

  //currentCreateSubRouteCollaborator: ICreateSubRouteDeliveryTimes = this.initializeCreateSubRouteCollaborator();
  currentUpdateFrequencies: FrequenciesAttributes | undefined;

  currentCreateFrequencies: ICreateSubRouteFrequency =
    this.initializeCreateSubRouteFrequency();

  constructor(
    private dialog: MatDialog,
    private readonly frequencyService: SubRouteFrequenciesService,
    public dialogRef: MatDialogRef<AddFrequencies>,
    private snackBar: MatSnackBar,
    private readonly permissionService: PermissionService,

    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) {}

  ngAfterViewInit(): void {
    this.weekDays = this.daysList.map((day) => ({
      ...day,
      checked: false,
    }));
    this.getListFrequencies();
  }

  getListFrequencies() {
    this.frequencyService.findBySubRouteId(this.data._id).subscribe({
      next: (res) => {
        this.listCollaboratorsAdd = res?.data.filter(frecuency => frecuency.type == 'W')
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener el registro",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private initializeCreateSubRouteFrequency(): ICreateSubRouteFrequency {
    return {
      days: [],
      type: "W",
      dates: [],
      businessPartners: [],
    };
  }

  save() {
    this.dialogRef.close(this.currentCreateFrequencies);
  }

  resetFormAddListCollaborators() {}

  onDaySelectionChange(event: MatCheckboxChange, dayValue: number, item: any) {
    if (event.checked) {
      if (!item.days.includes(dayValue)) {
        item.days.push(dayValue);
      }
    } else {
      const index = item.days.indexOf(dayValue);
      if (index > -1) {
        item.days.splice(index, 1);
      }
    }
  }

  // El gate del template evita el click, pero el metodo tambien se alcanza por
  // otros caminos. La validacion va en los dos lados.
  private checkIfHasPermission(permission: string, errorMessage: string): boolean {
    const has = this.permissionService.has(permission);
    if (!has) {
      this.snackBar.open(errorMessage, "Cerrar", { duration: 5000 });
    }
    return has;
  }

  onAddToListDeliveryTimes() {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.CREATE, "No tienes permisos para crear frecuencias.")) {
      return;
    }

    let isAllSelected = this.weekDays.filter((day)=> !day.checked)
    if(isAllSelected.length == 7){ //significa que los 7 dias estan desabilitados
      this.snackBar.open("Seleccione al menos un día", 'Cerrar', { duration: 3000 });
      return;
    }

    this.currentCreateFrequencies.days = this.weekDays
      .filter((day) => day.checked)
      .map((day) => day.value);
    this.currentCreateFrequencies.businessPartners =
      this.currentCreateFrequencies.businessPartners || [];
    this.frequencyService
      .createEmbedded(this.data._id, this.currentCreateFrequencies)
      .subscribe({
        next: () => {
          this.snackBar.open("Frecuencia creado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.getListFrequencies()
          this.weekDays = this.daysList.map((day) => ({
            ...day,
            checked: false,
          }));
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al registrar frecuencia",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  onStatusChange(event: boolean, element) {
    const updatedStatusId = event ? 1 : 0;
    element.statusId = updatedStatusId;
  }

  onUpdateDeliveryTime(element, i) {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.UPDATE, "No tienes permisos para editar frecuencias.")) {
      return;
    }

    element.isEditMode = true;
  }

  onSaveDeliveryTime(element, i) {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.UPDATE, "No tienes permisos para editar frecuencias.")) {
      return;
    }

    element.isEditMode = false;

    this.frequencyService
      .updateEmbedded(this.data._id, element._id, element)
      .subscribe({
        next: () => {
          this.snackBar.open("Frecuencia actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.frequencyService
            .findBySubRouteId(this.data._id.toString())
            .subscribe((res) => {
              this.data.frequency = res?.data;
              this.listCollaboratorsAdd = this.data.frequency;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el frecuencia",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  onDeleteDeliveryTime(item: any): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.DELETE, "No tienes permisos para eliminar frecuencias.")) {
      return;
    }

    this.dialog
      .open(DeleteConfirmationComponent, {
        data: {
          message: `¿Estás seguro de eliminar la frecuencia con ${item.businessPartners.length} clientes?`,
          name: item,
        },
        panelClass: "delete-modal",
        disableClose:true
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteFrequency(item));
  }

  deleteFrequency(element) {
    this.frequencyService
      .deleteEmbedded1d(this.data._id, element._id)
      .subscribe({
        next: () => {
          this.snackBar.open("Frecuencia eliminado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.frequencyService
            .findBySubRouteId(this.data._id.toString())
            .subscribe((res) => {
              this.data.orderDeliveryWindows = res?.data;
              this.listCollaboratorsAdd = this.data.orderDeliveryWindows;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al eliminar el frecuencia",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  openFrecuencyModal(action: string, data?: FrequenciesAttributes) {
    const dialogRef = this.dialog.open(FrecuencyModalComponent, {
      panelClass: ".form-modal-interlocutor",
      data: action == "create" ? this.currentCreateFrequencies : data,
      width: "500px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (action == "create") {
        this.currentCreateFrequencies = result;
      } else {
        data = result;
      }
    });
  }
}
